import React from 'react';
import { PropTypes } from 'prop-types';

const HeroCarouselSlide = ({ imageUrl, contentBlock }) => (
    <div>
        <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                {contentBlock}
            </div>
        </div>
        <img src={imageUrl} />
    </div>
);

HeroCarouselSlide.propTypes = {
    imageUrl: PropTypes.string,
    contentBlock: PropTypes.element,
};

export default HeroCarouselSlide;
